/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'

import { EuiButton } from '@elastic/eui'

import { FormattedMessage } from '@modules/i18n'
import { useIsProjectInitializing } from '@modules/project-admin-lib/hooks/status'
import type { AnyAdminProject } from '@modules/project-admin-api/types'
import { isProjectSuspended } from '@modules/project-lib/suspended'

export type Props = {
  project: AnyAdminProject
}

const OpenProjectButton: React.FunctionComponent<Props> = ({ project }) => {
  const isInitializing = useIsProjectInitializing(project)

  const isSuspended = isProjectSuspended(project)

  return (
    <EuiButton
      fill={false}
      isDisabled={isInitializing || isSuspended}
      href={project.endpoints.kibana}
    >
      <FormattedMessage id='project.openButton' defaultMessage='Open project' />
    </EuiButton>
  )
}

export default OpenProjectButton
